import React from 'react';

const AppointmentApproved = ({ text }) => {
    return (
        <div className="container">
            <div id="confirmation_buttons" className="d-flex justify-content-center align-items-center flex-column">
                <div className="confirmationButtons_title p-0">{text}</div>
            </div>
        </div>
    );
}

export default AppointmentApproved;